import { useState } from 'react';
import DateInput from './DateInput';
import { fmtS, fmt$0 } from '../utils/formatters';
import { WEATHER, getCategories } from '../utils/categories';
import { supabase } from '../lib/supabase';

export default function DailySales({salesDate, setSalesDate, salesData, setSalesData, salesMeta, setSalesMeta, toastEnabled, weatherByDate, setWeatherByDate, todayS, t, si, sb, mn, isMobile, cashReceived, setCashReceived, save, orgId, uid, settings, session}) {
const m=isMobile;
const cashVal=parseFloat(String(cashReceived).replace(/,/g,""))||0;
const cardSales=Math.max(0,todayS-cashVal);
const[focused,setFocused]=useState(null);
const[saved,setSaved]=useState(false);
const[syncing,setSyncing]=useState(false);
const[syncErr,setSyncErr]=useState('');

// Toast state for the selected date
const meta=toastEnabled?salesMeta?.[salesDate]:null;
const isToastDay=meta?.source==='toast';

async function syncFromToast(){
  setSyncing(true);setSyncErr('');
  try{
    const token=session?.access_token||(await supabase.auth.getSession()).data?.session?.access_token;
    if(!token)throw new Error('Not logged in');
    const bizDate=salesDate.replace(/-/g,'');
    const r=await fetch(`/api/toast-sales-sync?org_id=${orgId}&date=${bizDate}&dry_run=false`,{
      method:'POST',
      headers:{Authorization:`Bearer ${token}`,'Content-Type':'application/json'},
      body:JSON.stringify({trigger:'manual_pull'}),
    });
    const d=await r.json();
    if(!r.ok)throw new Error(d.error||r.statusText);
    // Update salesData and meta from the sync result
    const newData={};
    for(const row of(d.plan||[])){if(row.action!=='skipped')newData[row.category]=String(row.amount);}
    // Merge with existing (keep skipped categories' current values)
    setSalesData(p=>{const merged={...p};for(const[k,v]of Object.entries(newData))merged[k]=v;return merged;});
    setSalesMeta(p=>({...p,[salesDate]:{source:'toast',synced_at:new Date().toISOString(),needs_review:d.summary?.needsReview||false,review_flags:d.summary?.reviewFlags!=='none'?d.summary?.reviewFlags:null}}));
    // Update cash received from sync result
    if(d.cashReceived!=null)setCashReceived(String(d.cashReceived));
  }catch(e){setSyncErr(e.message);}
  setSyncing(false);
}

function displayVal(raw){
  const n=parseFloat(String(raw).replace(/[^0-9.-]/g,''))||0;
  if(!raw&&raw!==0)return'';
  return'$'+fmt$0(n);
}
function editVal(raw){return String(raw).replace(/[$,]/g,'');}

return(<div>
<h1 style={{fontSize:m?18:22,fontWeight:700,margin:"0 0 20px"}}>Daily Sales</h1>
<div style={{display:"flex",gap:12,alignItems:m?"stretch":"center",marginBottom:20,flexWrap:m?"wrap":"nowrap"}}><DateInput value={salesDate} onChange={e=>setSalesDate(e.target.value)} style={{...si,width:m?"100%":180}}/><select value={weatherByDate[salesDate]||""} onChange={e=>setWeatherByDate(p=>({...p,[salesDate]:e.target.value}))} style={{...si,width:m?"100%":140}}><option value="">Weather...</option>{WEATHER.map(w=><option key={w}>{w}</option>)}</select><div style={{background:t.cd,borderRadius:10,border:`1px solid ${t.bd}`,padding:"10px 18px",width:m?"100%":undefined,textAlign:m?"center":undefined}}><span style={{fontSize:10,color:t.tm}}>Net Sales </span><span style={{fontFamily:mn,fontSize:20,fontWeight:700,color:t.gn}}>${fmt$0(todayS)}</span></div>
{toastEnabled&&<button onClick={syncFromToast} disabled={syncing} style={{...sb,background:t.bl,color:'#fff',fontSize:11,padding:'8px 16px',whiteSpace:'nowrap'}}>{syncing?'Syncing...':'Sync from Toast'}</button>}
</div>

{/* Review warning for Toast-synced days with flags */}
{isToastDay&&meta.needs_review&&meta.review_flags?.length>0&&<div style={{background:'rgba(212,168,36,0.08)',border:`1px solid ${t.yl}`,borderRadius:8,padding:'8px 14px',marginBottom:12,fontSize:11,color:t.yl}}>
<span style={{fontWeight:600}}>Needs review:</span> {meta.review_flags.map(f=>f.replace(/_/g,' ')).join(', ')}
</div>}

{syncErr&&<div style={{background:'rgba(200,55,45,0.08)',border:`1px solid ${t.ac}`,borderRadius:8,padding:'8px 14px',marginBottom:12,fontSize:11,color:t.ac}}>{syncErr}</div>}

<div style={{background:t.cd,borderRadius:12,border:`1px solid ${t.bd}`,padding:m?16:20}}>
<div style={{display:"grid",gridTemplateColumns:m?"1fr":"1fr 1fr",gap:12}}>{getCategories(settings).map(cat=><div key={cat} style={{display:"flex",alignItems:"center",gap:10}}>
<label style={{fontSize:12,fontWeight:500,width:m?120:160}}>{cat}{isToastDay&&<span style={{fontSize:8,padding:'1px 5px',borderRadius:3,background:'rgba(59,130,246,0.1)',color:t.bl,marginLeft:6,fontWeight:600}}>Toast</span>}</label>
{isToastDay
  ?<span style={{flex:1,fontFamily:mn,fontSize:14,padding:'8px 10px',color:t.tm,background:t.sf,borderRadius:6}}>{displayVal(salesData[cat])||'$0.00'}</span>
  :<input
    value={focused===cat?editVal(salesData[cat]):displayVal(salesData[cat])}
    onChange={e=>setSalesData(p=>({...p,[cat]:fmtS(e.target.value)}))}
    onFocus={e=>{setFocused(cat);e.target.select();}}
    onBlur={()=>setFocused(null)}
    placeholder="$0.00"
    style={{...si,flex:1,fontFamily:mn,fontSize:14}}
  />}
</div>)}</div>
<div style={{display:"flex",gap:m?12:24,alignItems:"center",marginTop:16,paddingTop:16,borderTop:`1px solid ${t.bd}`,flexWrap:m?"wrap":"nowrap"}}>
<div style={{display:"flex",alignItems:"center",gap:8,flex:m?undefined:1,width:m?"100%":undefined}}><label style={{fontSize:12,fontWeight:500,whiteSpace:"nowrap"}}>Cash Received{isToastDay&&<span style={{fontSize:8,padding:'1px 5px',borderRadius:3,background:'rgba(59,130,246,0.1)',color:t.bl,marginLeft:6,fontWeight:600}}>Toast</span>}</label>
{isToastDay
  ?<span style={{flex:1,fontFamily:mn,fontSize:14,padding:'8px 10px',color:t.tm,background:t.sf,borderRadius:6}}>{displayVal(cashReceived)||'$0.00'}</span>
  :<input
    value={focused==='cash'?editVal(cashReceived):displayVal(cashReceived)}
    onChange={e=>setCashReceived(fmtS(e.target.value))}
    onFocus={e=>{setFocused('cash');e.target.select();}}
    onBlur={()=>setFocused(null)}
    placeholder="$0.00"
    style={{...si,flex:1,fontFamily:mn,fontSize:14}}
  />}
</div>
<div style={{display:"flex",gap:16,alignItems:m?"center":"center",flex:m?undefined:1,width:m?"100%":undefined,justifyContent:m?"space-between":"flex-end"}}>
<div><span style={{fontSize:10,color:t.td}}>Card Sales </span><span style={{fontFamily:mn,fontSize:14,fontWeight:600,color:t.bl}}>${fmt$0(cardSales)}</span></div>
<div><span style={{fontSize:10,color:t.td}}>Cash </span><span style={{fontFamily:mn,fontSize:14,fontWeight:600,color:t.gn}}>${fmt$0(cashVal)}</span></div>
</div>
</div>
<div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginTop:12,paddingTop:12,borderTop:`1px solid ${t.bd}`}}>
<div style={{fontSize:14,fontWeight:600}}>Net: <span style={{fontFamily:mn,color:t.gn}}>${fmt$0(todayS)}</span></div>
<div style={{display:'flex',gap:8,alignItems:'center'}}>
{isToastDay&&meta.synced_at&&<span style={{fontSize:9,color:t.td}}>Synced {new Date(meta.synced_at).toLocaleString('en-US',{month:'short',day:'numeric',hour:'numeric',minute:'2-digit'})}</span>}
{!isToastDay&&save&&orgId&&uid?<button onClick={()=>{Object.entries(salesData||{}).forEach(([cat,amt])=>{if(amt!=="")save.saveSalesEntry(orgId,uid,salesDate,cat,amt);});save.saveLaborField(orgId,uid,salesDate,{cash_received:parseFloat(String(cashReceived).replace(/,/g,''))||0});setSaved(true);setTimeout(()=>setSaved(false),2000);}} style={{...sb,background:t.gn,fontSize:12,padding:'8px 20px'}}>{saved?'Saved ✓':'Save'}</button>:<span style={{fontSize:11,color:t.gn}}>{isToastDay?'':'Auto-saved'}</span>}
</div>
</div></div></div>);
}
